/* eslint react/prop-types:0 */
import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsWatermarkConfigurationRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceSettingsWatermarkConfigurationComponent" */ './SpaceSettingsWatermarkConfigurationComponent.tsx'
		),
});

export const SpaceSettingsWatermarkConfigurationRoute = ({ params: { spaceKey } }) => (
	<SpaceSettingsWatermarkConfigurationRouteComponent spaceKey={spaceKey} />
);

SpaceSettingsWatermarkConfigurationRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } },
	isNav4Enabled,
) => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsWatermarkConfiguration', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
